import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import ShowField from './components/ShowField';
import SearchResults from './components/SearchResults';
import 'bootstrap/dist/css/bootstrap.css';
import { NotFound } from './components/NotFound';
import { Privacy } from './components/Privacy';
import { Terms } from './components/Terms';
import { ErrorBoundary } from './components/ErrorBoundary';
import { installErrorTracking } from './utilities/errorTracking';

installErrorTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router>
          <Routes>
            <Route path="/" element={<App/>} />

            <Route path="/search" element={
              <SearchResults />}
              />

            <Route path="/fields/:fieldID" element={<ShowField />} />

            <Route path="/privacy" element={<Privacy />} />
            <Route path="/privacy.html" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/terms.html" element={<Terms />} />

              <Route path="*" element={<NotFound />}/>
          </Routes>
      </Router>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
